module.exports = __webpack_public_path__ + "static/media/grindavikurvegur.e12c2a01.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/grindavikurvegur.png
 ** module id = 184
 ** module chunks = 0
 **/